let serverUrl

switch (process.env.VUE_APP_NODE_ENV || process.argv[2]) {
  case 'prod':
    serverUrl = 'https://api.japanparts.com.br/api'
    break

  case 'dev':
    serverUrl = 'https://new-fastlube-api.launchpad.com.br/api'
    break

  default:
    serverUrl = 'https://api.japanparts.com.br/api'
    break
}

export default { //eslint-disable-line
  NODE_ENV: 'production',
  ROOT_API: serverUrl
}





// WEBPACK FOOTER //
// ./src/config/prod.env.js